import { render } from "./CompanyContactPageList.vue?vue&type=template&id=c979a892&scoped=true&ts=true"
import script from "./CompanyContactPageList.vue?vue&type=script&lang=ts"
export * from "./CompanyContactPageList.vue?vue&type=script&lang=ts"

import "./CompanyContactPageList.vue?vue&type=style&index=0&id=c979a892&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c979a892"]])

export default __exports__